import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/Navbar.css';

const Navbar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const schoolName = 'St. Therese of the Child Jesus Multiple Intelligence School';

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    return (
        <nav className={`navbar primary-blue-background ${isMenuOpen ? 'open' : ''}`}>
            {/* <Logo /> */}
            <Link to="/">
                <div className='flex-center'>
                    <div className='logo image'/>
                    <div className='logo-name inter bold'>{schoolName}</div>
                </div>
            </Link>
            {/* LINKS */}
            <div className={`nav-links-container palanquin-dark flex-center${isMenuOpen ? 'open' : ''}`}>
                <a
                    href="/about"
                    className={activeLink === 'about' ? 'active' : ''}
                    onClick={() => setActiveLink('about')}
                >
                    About Us
                </a>
                <a
                    href="/admission"
                    className={activeLink === 'admission' ? 'active' : ''}
                    onClick={() => setActiveLink('admission')}
                >
                    Admission
                </a>
                <a
                    href="/programs"
                    className={activeLink === 'programs' ? 'active' : ''}
                    onClick={() => setActiveLink('programs')}
                >
                    Programs
                </a>
                <a
                    href="/faqs"
                    className={activeLink === 'faqs' ? 'active' : ''}
                    onClick={() => setActiveLink('faqs')}
                >
                    FAQs
                </a>
            </div>
            {/* <div className='menu-toggle' onClick={toggleMenu}>
                <div className='bar'></div>
                <div className='bar'></div>
                <div className='bar'></div>
            </div> */}
        </nav>
    );
};

export default Navbar;
